import { render, staticRenderFns } from "./IconCreateTask.vue?vue&type=template&id=6aa09a62"
import script from "./IconCreateTask.vue?vue&type=script&lang=js"
export * from "./IconCreateTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports